<script>
  import BaseStep from "./BaseStep.svelte";
  import Button from "../Button.svelte";
  import { NavigationType, hasNextPage } from "../../lib/stores/session";
  import { navigateTo } from "../../lib/routing";
  export let currentRoute;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <h1 class="mt-6 mb-6">Hello, World!</h1>

    <Button primary disabled={!$hasNextPage} on:click={() => navigateTo(NavigationType.Next)}>Next</Button>
  </svelte:fragment>
</BaseStep>
